var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M15.7 2H8.3a2.77 2.77 0 0 0-2.77 2.77v14.46A2.77 2.77 0 0 0 8.3 22h7.4a2.77 2.77 0 0 0 2.77-2.77V4.77A2.77 2.77 0 0 0 15.7 2",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M8.95 6.64a1.12 1.12 0 1 0 0-2.24 1.12 1.12 0 0 0 0 2.24"
  })));
};
export default SvgMobile;